<template>
  <div class="bg">
    <table></table>
    <canvas id="canvas"></canvas>
    <div style="width: 1300px; margin: 0 auto">
      <div class="row justify-content-center">
        <div class="col-xs-6 col-lg-6 p-0" style="margin-top: 150px">
          <div
            id="backImage"
            class="w-100 h-100"
            style="
              background-image: url('../../static/images/shangcheng.jpg');
              background-size: 100% 100%;
              background-repeat: no-repeat;
              border-radius: 4px;
            "
          ></div>
        </div>

        <div class="col-lg-6 col-md-12 col-xs-12">
          <h4 style="margin-top: 112px; text-align: center">
            <a href="http://fxapp.hyey.cn/android/fwhyey.apk" style="color: red"
              >掌上华源下载</a
            >
            <a
              class="zhangshang_c"
              href="javascript:;"
              @click="zhangshang()"
              style="font-size: 15px; color: #999; margin-left: 30px"
              >掌上华源服务协议</a
            >
          </h4>
          <div class="card">
            <div
              class="card-header border-bottom text-center"
              @click="showBack()"
            >
              <h4 class="card-title" style="color: #3190e8">会员登录</h4>
            </div>
            <div class="card-body">
              <div class="form-group">
                <input
                  class="form-control"
                  :class="{ form_border: form_border1 }"
                  type="text"
                  required=""
                  placeholder="用户名"
                  v-model="form.username"
                  @keyup="username"
                />
                <span
                  style="display: block; font-size: 15px; margin-top: 10px"
                  class="inputdown d-none"
                  id="username"
                  >用户名：只能包括数字字母的组合，长度为4-15位</span
                >
              </div>
              <div class="form-group biaoshi">
                <input
                  class="form-control"
                  :class="{ form_border: form_border2 }"
                  :type="typePwd"
                  required=""
                  placeholder="密码"
                  v-model="form.password"
                  @keyup="password"
                />

                <img
                  :src="seen ? openeye : nopeneye"
                  class="iconfont"
                  alt=""
                  @click="changeType()"
                />
                <span
                  style="display: block; font-size: 15px; margin-top: 10px"
                  class="d-none inputdown"
                  id="password"
                  >密码：只能包括数字字母组合,长度为3-15位</span
                >
              </div>
              <div class="form-group row" v-if="showcode">
                <div class="col-lg-6">
                  <input
                    class="form-control mt-2"
                    type="text"
                    placeholder="验证码"
                    v-model="form.yzm"
                  />
                </div>
                <div class="col-lg-6">
                  <div>
                    <img
                      :src="imageSrc"
                      class="mt-1"
                      style="width: 120px; height: 45px"
                      alt=""
                      @click="getImageSrc"
                    />
                  </div>
                </div>
              </div>
              <div class="d-none">
                <input
                  type="text"
                  placeholder="tokenid"
                  v-model="form.tokenid"
                />
              </div>
              <div class="form-group">
                <div class="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    v-model="checked"
                    class="custom-control-input"
                    id="customCheck1"
                  />
                  <label class="custom-control-label" for="customCheck1"
                    >记住我</label
                  >
                </div>
              </div>
              <div class="form-group text-center m-t-20">
                <button
                  class="btn btn-primary btn-block"
                  type="submit"
                  @click="onSubmit"
                >
                  登录
                </button>
              </div>
              <div class="form-group">
                <div class="float-right">
                  <a href="" class="text-muted"
                    ><i class="lni-lock"></i> 忘记密码？</a
                  >
                </div>
                <div class="float-left">
                  <router-link class="text-muted" to="">
                    <span> 注册新用户 </span>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style="
          font-size: 10px;
          margin-top: 120px;
          text-shadow: #808080 0.5px 0 0;
        "
      >
        <p class="text-center mb-1">
          药品信息提供：安徽华源医药集团股份有限公司
          版权所有：安徽华源医药电子商务有限公司
          系统维护：安徽华源医药电子商务有限公司
        </p>
        <p class="text-center mb-1">
          地址：太和县沙河东路168号 邮编：236600 E-mail：service@hyey.com
          电话：0558-8653919
        </p>
        <p class="text-center mb-1">
          互联网药品信息服务资格证书 证书编号：（皖）-经营性-2013-0002
          备案号：皖B2-20090007-1
        </p>
        <p class="text-center mb-1">
          互联网药品交易服务资格证书 证书编号： 皖-B-2014-0001
        </p>
        <p class="text-center mb-1">增值电信业务许可证号：皖 B2-20130021</p>
      </div>
    </div>

    <!-- 弹出框内容 -->
    <div
      class="modal fade"
      id="myModal1"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div
          class="modal-content"
          style="
            width: 600px;
            height: 400px;
            position: relative;
            top: 200px;
            left: 200px;
          "
        >
          <div class="modal-body" style="font-size: 20px">
            <div
              style="
                width: 400px;
                height: 268px;
                margin: 0 auto;
                text-align: center;
                margin-bottom: 30px;
                margin-top: 30px;
                color: red;
                overflow: auto;
              "
            >
              <ul v-for="(item, index) in tableData" :key="index">
                <li>
                  <span>{{ index + 1 }}</span>
                  <span>
                    {{ item }}
                  </span>
                </li>
              </ul>
            </div>

            <div style="text-align: right">
              <button
                type="button"
                class="btn btn-primary"
                data-dismiss="modal"
              >
                <span aria-hidden="true"></span>确认
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Login",
  data() {
    return {
      showcode: false,
      form: {
        username: "",
        password: "",
        yzm: "",
        tokenid: "",
        phone_uuid: "",
        ipcode: "",
      },
      imageSrc: "",
      form_border1: false,
      form_border2: false,
      checked: true,
      tableData: [],
      seen: "",
      typePwd: "password",
      openeye: require("../../static/images/005yanjing-3.png"),
      nopeneye: require("../../static/images/005yanjing-2.png"),
    };
  },
  components: {},
  methods: {
    zhangshang() {
      this.$router.push({ path: "/yssm" });
    },
    changeType() {
      this.typePwd = this.typePwd === "password" ? "text" : "password";
      this.seen = !this.seen;
    },
    //判断是否登录
    getClerkToDoList: async function () {
      const { data: res } = await this.$http.post("Dls/getFun", {
        action: "ClerkToDoList",
        obj: JSON.stringify({}),
      });
      //
      if (res.data.isChecked) {
        this.$router.push({ path: "/index" });
        this.$message.success("登录成功!");
      } else {
        const obj = res.data;
        this.tableData = obj.msgList;

        $("#myModal1").modal();
        window.sessionStorage.setItem("tokenid", "");
      }
    },

    //设置cookie
    setCookie(c_name, c_pwd, exdays) {
      var exdate = new Date(); //获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
      //字符串拼接cookie
      window.document.cookie =
        "userName" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
      window.document.cookie =
        "userPwd" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
    },
    //读取cookie
    getCookie: function () {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; "); //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("="); //再次切割
          //判断查找相对应的值
          if (arr2[0] == "userName") {
            this.form.username = arr2[1]; //保存到保存数据的地方
          } else if (arr2[0] == "userPwd") {
            this.form.password = arr2[1];
          }
        }
      }
    },
    //清除cookie
    clearCookie: function () {
      this.setCookie("", "", -1); //修改2值都为空，天数为负1天就好了
    },

    userBehaviorFun: function () {},
    showBack: function () {},
    username: function () {
      let reg1 = /^[A-Za-z0-9]{4,15}$/;
      if (!reg1.test(this.form.username)) {
        this.form_border1 = true;
        $("#username").removeClass("d-none");
      } else {
        this.form_border1 = false;
        $("#username").addClass("d-none");
      }
    },
    password: function () {
      let reg2 = /^[a-z+A-Z+0-9+]{3,15}$/;
      if (!reg2.test(this.form.password)) {
        this.form_border2 = true;
        $("#password").removeClass("d-none");
      } else {
        this.form_border2 = false;
        $("#password").addClass("d-none");
      }
    },
    onSubmit: async function () {
      let reg1 = /^[A-Za-z0-9]{4,15}$/;
      let reg2 = /^[a-z+A-Z+0-9+]{3,15}$/;
      if (!reg1.test(this.form.username) && !reg2.test(this.form.password)) {
        alert("输入信息格式不正确");
      } else {
        //

        const that = this;

        if (that.checked == true) {
          //传入账号名，密码，和保存天数3个参数
          that.setCookie(that.form.username, that.form.password, 7);
        } else {
          //清空Cookie
          that.clearCookie();
        }

        //  that.form.phone_uuid=that.form.username+'websidelogin'
        const { data: res } = await that.$http.post(
          "Home/doLogin",
          that.form,
          {}
        );

        //

        if (res.isok) {
          window.sessionStorage.setItem("boss", res.data.boss);
          window.sessionStorage.setItem("uSERNAME", res.data.username);
          window.sessionStorage.setItem("phone_uuid", that.form.phone_uuid);
          window.sessionStorage.setItem("groupid", res.data.groupid);
          window.sessionStorage.setItem("tokenid", res.data.tokenid);
          window.sessionStorage.setItem("username", res.data.username);
          window.sessionStorage.setItem("pwd", that.form.password);
          window.sessionStorage.setItem("mobile", res.data.mobile);
          if(res.data.ipcode==null || res.data.ipcode==""){

              //console.log(111111)
          }else{
            localStorage.setItem("ipcode", res.data.ipcode);
              //console.log(res.data.ipcode)
            //console.log(localStorage.getItem("ipcode"))
          }

          // alert("登录成功")
          // that.$message.success("登录成功!")

          if (res.data.groupid == 5 || res.data.groupid == 888) {
            that.getClerkToDoList();
          } else if (res.data.groupid == 2) {
            that.$router.push({ path: "/checkMeeting" });
            that.$message.success("登录成功!");
          } else if (res.data.groupid == 3) {
            that.$router.push({ path: "/summaryMeeting" });
            that.$message.success("登录成功!");
          } else if (res.data.groupid == 4) {
            that.$router.push({ path: "/superviseMeeting" });
            that.$message.success("登录成功!");
          } else if (res.data.groupid == 51) {
            that.$router.push({ path: "/saleQuery" });
            that.$message.success("登录成功!");
          } else if (res.data.groupid == 7) {
            that.$router.push({ path: "/index" });
            that.$message.success("登录成功!");
          } else if (res.data.groupid == 87) {
            that.$router.push({ path: "/fybx" });
            that.$message.success("登录成功!");
          } else if (res.data.groupid == 26) {
            that.$router.push({ path: "/index" });
            that.$message.success("登录成功!");
          } else if (res.data.groupid == 33) {
            that.$router.push({ path: "/summaryMeeting" });
            that.$message.success("登录成功!");
          } else if (res.data.groupid == 666) {
            that.$router.push({ path: "/inventory" });
            that.$message.success("登录成功!");
          } else if (res.data.groupid == 66) {
            that.$router.push({ path: "/salesGournal" });
            that.$message.success("登录成功!");
          } else if (res.data.groupid == 77 || res.data.groupid == 81) {
            that.$router.push({ path: "/salesGournal" });
            that.$message.success("登录成功!");
          } else if (res.data.groupid == 78) {
            that.$router.push({ path: "/weeklyReport" });
            that.$message.success("登录成功!");
          }
        } else if (res.code == -2) {
          that.$router.push({ path: "/approve" });
        } else {
          if (res.code == -4) {
            this.showcode = true;
          }
          alert(res.message);
        }
      }
    },
    getImageSrc: async function () {
      let that = this;
      await that.$http
        .get("Home/getCode", {
          responseType: "arraybuffer",
        })
        .then((response) => {
          that.form.tokenid = response.headers.tokenid;
          that.imageSrc =
            "data:image/png;base64," +
            btoa(
              new Uint8Array(response.data).reduce(
                (data, byte) => data + String.fromCharCode(byte),
                ""
              )
            );
        });
    },
    clearLogin: function () {
      window.sessionStorage.clear();
    },
  },
  mounted: function () {
    class Circle {
      //创建对象
      //以一个圆为对象
      //设置随机的 x，y坐标，r半径，_mx，_my移动的距离
      //this.r是创建圆的半径，参数越大半径越大
      //this._mx,this._my是移动的距离，参数越大移动
      constructor(x, y) {
        this.x = x;
        this.y = y;
        this.r = Math.random() * 10;
        this._mx = Math.random();
        this._my = Math.random();
      }

      //canvas 画圆和画直线
      //画圆就是正常的用canvas画一个圆
      //画直线是两个圆连线，为了避免直线过多，给圆圈距离设置了一个值，距离很远的圆圈，就不做连线处理
      drawCircle(ctx) {
        ctx.beginPath();
        //arc() 方法使用一个中心点和半径，为一个画布的当前子路径添加一条弧。
        ctx.arc(this.x, this.y, this.r, 0, 360);
        ctx.closePath();
        ctx.fillStyle = "rgba(204, 204, 204, 0.3)";
        ctx.fill();
      }

      drawLine(ctx, _circle) {
        let dx = this.x - _circle.x;
        let dy = this.y - _circle.y;
        let d = Math.sqrt(dx * dx + dy * dy);
        if (d < 150) {
          ctx.beginPath();
          //开始一条路径，移动到位置 this.x,this.y。创建到达位置 _circle.x,_circle.y 的一条线：
          ctx.moveTo(this.x, this.y); //起始点
          ctx.lineTo(_circle.x, _circle.y); //终点
          ctx.closePath();
          ctx.strokeStyle = "rgba(204, 204, 204, 0.3)";
          ctx.stroke();
        }
      }

      // 圆圈移动
      // 圆圈移动的距离必须在屏幕范围内
      move(w, h) {
        this._mx = this.x < w && this.x > 0 ? this._mx : -this._mx;
        this._my = this.y < h && this.y > 0 ? this._my : -this._my;
        this.x += this._mx / 2;
        this.y += this._my / 2;
      }
    }

    //鼠标点画圆闪烁变动
    class currentCirle extends Circle {
      constructor(x, y) {
        super(x, y);
      }

      drawCircle(ctx) {
        ctx.beginPath();
        //注释内容为鼠标焦点的地方圆圈半径变化
        //this.r = (this.r < 14 && this.r > 1) ? this.r + (Math.random() * 2 - 1) : 2;
        this.r = 8;
        ctx.arc(this.x, this.y, this.r, 0, 360);
        ctx.closePath();
        //ctx.fillStyle = 'rgba(0,0,0,' + (parseInt(Math.random() * 100) / 100) + ')'
        ctx.fillStyle = "rgba(255, 77, 54, 0.6)";
        ctx.fill();
      }
    }

    //更新页面用requestAnimationFrame替代setTimeout
    window.requestAnimationFrame =
      window.requestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.msRequestAnimationFrame;

    let canvas = document.getElementById("canvas");
    let ctx = canvas.getContext("2d");
    let w = (canvas.width = canvas.offsetWidth);
    let h = (canvas.height = canvas.offsetHeight);
    let circles = [];
    let current_circle = new currentCirle(0, 0);

    let draw = function () {
      ctx.clearRect(0, 0, w, h);
      for (let i = 0; i < circles.length; i++) {
        circles[i].move(w, h);
        circles[i].drawCircle(ctx);
        for (let j = i + 1; j < circles.length; j++) {
          circles[i].drawLine(ctx, circles[j]);
        }
      }
      if (current_circle.x) {
        current_circle.drawCircle(ctx);
        for (var k = 1; k < circles.length; k++) {
          current_circle.drawLine(ctx, circles[k]);
        }
      }
      requestAnimationFrame(draw);
    };

    let init = function (num) {
      for (var i = 0; i < num; i++) {
        circles.push(new Circle(Math.random() * w, Math.random() * h));
      }
      draw();
    };

    window.addEventListener("load", init(60));

    window.onmousemove = function (e) {
      e = e || window.event;
      current_circle.x = e.clientX;
      current_circle.y = e.clientY;
    };

    window.onmouseout = function () {
      current_circle.x = null;
      current_circle.y = null;
    };
  },
  created: async function () {
    this.getCookie();
    const that = this;
    await that.getImageSrc();
    var user = window.sessionStorage.getItem("username");
    var pwd = window.sessionStorage.getItem("pwd");
     var ipcode = localStorage.getItem("ipcode");
     that.form.ipcode = ipcode;
    if (user == null || pwd == null) {
    } else {
      that.form.username = user;
      that.form.password = pwd;
    }

    // that.clearLogin()
    // document.querySelector('body').setAttribute('style', "background-image:url('../../static/images/bg1.jpg');background-repeat:no-repeat;background-size:100% 200%"

    //  )
  },
  //创建前设置
  beforeCreate() {},
  //销毁前清除
  beforeDestroy() {
    //  document.querySelector('body').removeAttribute('style')
  },
};
</script>
<style scoped>
html {
  height: 100%;
}
.bg {
  background-image: url("../../static/images/bg1.jpg");
  background-size: 100% 100%;
  width: 100%;
  height: 100vh;
  background-repeat: no-repeat;
}
.inputdown {
  color: red;
}
#backImage {
  transition-property: all;
  transition-duration: 2s;
}
#backImage:hover {
  margin-left: 580px;
}
#canvas {
  position: absolute;
  margin: 0 auto;
  display: block;
  width: 100%;
  height: 100vh;
}
.form_border {
  border-color: red;
  outline: 0;
  -webkit-box-shadow: inset 0 1px 1px rgba(26, 23, 23, 0.075),
    0 0 8px rgba(255, 0, 0, 0.6);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(255, 0, 0, 0.6);
}

.biaoshi {
  position: relative;
}
.iconfont {
  position: absolute;
  top: 8px;
  right: 40px;
  width: 25px;
  height: 25px;
  z-index: 2;
}

.zhangshang_c:hover {
  font-size: 12px;
  color: #999999;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue